import { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import card1 from "../../../assets/img/projects/JppCompta/img1.png";
import card2 from "../../../assets/img/projects/JppCompta/img2.png";

gsap.registerPlugin(ScrollTrigger);

export default function Card() {
  const containerRef = useRef(null);
  const image1Ref = useRef(null);
  const image2Ref = useRef(null);

  useLayoutEffect(() => {
    const ctx = gsap.context(() => {
      // Animation de la première image (gauche) - arrive d'en haut
      gsap.fromTo(
        image1Ref.current,
        { y: -100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );

      // Animation de la deuxième image (droite) - arrive d'en bas
      gsap.fromTo(
        image2Ref.current,
        { y: 100, opacity: 0 },
        {
          y: 0,
          opacity: 1,
          duration: 1,
          delay: 0.3,
          ease: "power2.out",
          scrollTrigger: {
            trigger: containerRef.current,
            start: "top 80%",
            toggleActions: "play none none reverse",
          },
        }
      );
    }, containerRef);

    return () => ctx.revert();
  }, []);

  return (
    <div className="JppCompta-cards" ref={containerRef}>
      <div ref={image1Ref}>
        <img src={card1} alt="" />
      </div>
      <div ref={image2Ref}>
        <img src={card2} alt="" />
      </div>
    </div>
  );
}
